import dayjs from 'dayjs';
import { BaseEntity, JsonApiProperty, JsonApiResource } from '../jsonapi-provider';
import { LocalDate } from '../utils/local-date';

@JsonApiResource({
  type: 'customer-cycle-menu',
})
export default class CycleMenu extends BaseEntity {
  name: string = '';
  @JsonApiProperty({ resolver: (val: any) => new LocalDate(val) }) startDate = new LocalDate();
  @JsonApiProperty({ resolver: (val: any) => new LocalDate(val) }) endDate = new LocalDate().add(
    1,
    'd'
  );

  @JsonApiProperty({ resolver: (val) => (val ? new LocalDate(val) : null) })
  repeatUntil: LocalDate | null = null;

  @JsonApiProperty({ resolver: (val) => (val ? new LocalDate(val) : null) })
  effectiveEndDate: LocalDate = new LocalDate();

  isEnabled = true;

  get cycleLength(): number {
    return this.endDate.add(1, 'd').diff(this.startDate, 'd');
  }

  get repeats(): Array<{ start: LocalDate; end: LocalDate }> {
    if (this.repeatUntil == null) return [{ start: this.startDate, end: this.endDate }];

    const ret = [];
    for (let cur = this.startDate; cur <= this.repeatUntil; cur = cur.add(this.cycleLength, 'd')) {
      ret.push({
        start: cur,
        end: new LocalDate(
          dayjs.min(cur.add(this.cycleLength - 1, 'd').toDayjs(), this.repeatUntil.toDayjs())
        ),
      });
    }
    return ret;
  }

  getDateRange(): [LocalDate, LocalDate] {
    return [this.startDate, this.repeatUntil ?? this.endDate];
  }
}
